import { Platform } from 'react-native';
import { z } from 'zod';

import {
	PASSWORD_MIN_LENGTH,
	USERNAME_MAX_LENGTH,
	USERNAME_MIN_LENGTH,
	USERNAME_REGEX,
} from '@pletly/shared';

const REGISTRATION_ENABLED = Platform.OS !== 'web';

const passwordSchema = z
	.string()
	.min(PASSWORD_MIN_LENGTH)
	.refine((value) => /\d/.test(value), {
		params: { i18n: { key: 'errors.at_least_numbers', values: { minimum: 1 } } },
	})
	.refine((value) => /[!#$%&'()*+,-./:;<=>?@[\]^_{|}~]/.test(value), {
		params: { i18n: { key: 'errors.at_least_special_characters', values: { minimum: 1 } } },
	});

const usernameSchema = z
	.string()
	.min(USERNAME_MIN_LENGTH)
	.max(USERNAME_MAX_LENGTH)
	.refine((value) => USERNAME_REGEX.test(value), {
		params: { i18n: 'errors.only_letters_numbers_underscores' },
	});

export { REGISTRATION_ENABLED, usernameSchema, passwordSchema };
